module.exports = __webpack_public_path__ + "static/media/photo-2.d9c713be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/alabama-rural-studio/photo-2.jpg
// module id = 150
// module chunks = 0